/*
 *******************************************************************************
 *
 *  Filename:   /redux/slices/procedures.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Procedures redux reducer
 *
 *  Author:     Norman J. Nolasco [ Archetact Software ]
 *
 *  Created:    Thursday, June 13, 2024 - 5:28 PM (CST)
 *
 *  Notes:
 *
 *  Revisions:
 *              2024/06/13  NJN Initial Build
 *
 *  Copyright (c) 2024 - Archetact Software - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  procedureid: 0,
  proceduregroupid: 0,
  error: null,
  defaultToolPanel: "filter",
  order: "NAME ASC",
  search: "",
  columnState: [],
};

const intFields = ["procedureid", "proceduregroupid"];

const updateFieldReducer = (state, action, field) => {
  const value = action.payload ? action.payload[field] : undefined;

  if (value !== undefined) {
    state[field] = intFields.includes(field) ? parseInt(value, 10) : value;
    state.error = Number.isNaN(state[field]) ? `Invalid value for ${field}.` : null;
  } else {
    state.error = `No ${field} provided.`;
  }
};

export const sessionSlice = createSlice({
  name: "patients",
  initialState,
  reducers: {
    updateProcedureID: (state, action) => updateFieldReducer(state, action, "procedureid"),
    updateProcedureGroupID: (state, action) => updateFieldReducer(state, action, "proceduregroupid"),
    updateDefaultToolPanel: (state, action) => updateFieldReducer(state, action, "defaultToolPanel"),
    updateColumnState: (state, action) => updateFieldReducer(state, action, "columnState"),
  },
});

export const { updateProcedureID, updateProcedureGroupID, updateDefaultToolPanel, updateColumnState } =
  sessionSlice.actions;

export default sessionSlice.reducer;
